import { message } from 'ant-design-vue'
import {
  postPayloadCommands,
  putThermalProperty,
  PayloadCommandsEnum,
  IrMeteringMode,
  PostIrMeteringModeBody,
  PostIrMeteringPointBody,
  PostIrMeteringAreaBody,
  ThermalPaletteStyle,
  ThermalGainMode,
  SwitchAction,
} from '/@/api/drone-control/payload'

export function useThermalControl () {
  async function setIrMeteringMode (sn: string, data: PostIrMeteringModeBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringModeSet,
      data
    })
    if (code === 0) {
      message.success('IR metering mode set successfully')
    }
  }

  async function setIrMeteringPoint (sn: string, data: PostIrMeteringPointBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringPointSet,
      data
    })
    if (code === 0) {
      message.success('IR metering point set successfully')
    }
  }

  async function setIrMeteringArea (sn: string, data: PostIrMeteringAreaBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringAreaSet,
      data
    })
    if (code === 0) {
      message.success('IR metering area set successfully')
    }
  }

  async function setThermalPaletteStyle (sn: string, payloadIndex: string, value: ThermalPaletteStyle) {
    const { code } = await putThermalProperty(sn, {
      payload_index: payloadIndex,
      property: 'thermal_current_palette_style',
      value
    })
    if (code === 0) {
      message.success('Thermal palette updated')
    }
  }

  async function setThermalGainMode (sn: string, payloadIndex: string, value: ThermalGainMode) {
    const { code } = await putThermalProperty(sn, {
      payload_index: payloadIndex,
      property: 'thermal_gain_mode',
      value
    })
    if (code === 0) {
      message.success('Thermal gain mode updated')
    }
  }

  async function setThermalIsothermState (sn: string, payloadIndex: string, value: SwitchAction) {
    const { code } = await putThermalProperty(sn, {
      payload_index: payloadIndex,
      property: 'thermal_isotherm_state',
      value
    })
    if (code === 0) {
      message.success('Thermal isotherm state updated')
    }
  }

  async function setThermalIsothermUpperLimit (sn: string, payloadIndex: string, value: number) {
    const { code } = await putThermalProperty(sn, {
      payload_index: payloadIndex,
      property: 'thermal_isotherm_upper_limit',
      value
    })
    if (code === 0) {
      message.success('Thermal isotherm upper limit updated')
    }
  }

  async function setThermalIsothermLowerLimit (sn: string, payloadIndex: string, value: number) {
    const { code } = await putThermalProperty(sn, {
      payload_index: payloadIndex,
      property: 'thermal_isotherm_lower_limit',
      value
    })
    if (code === 0) {
      message.success('Thermal isotherm lower limit updated')
    }
  }

  return {
    setIrMeteringMode,
    setIrMeteringPoint,
    setIrMeteringArea,
    setThermalPaletteStyle,
    setThermalGainMode,
    setThermalIsothermState,
    setThermalIsothermUpperLimit,
    setThermalIsothermLowerLimit,
  }
}

export { IrMeteringMode, ThermalPaletteStyle, ThermalGainMode, SwitchAction }
